import React, { useState } from "react";
import Modal from "react-modal";
import emailjs from "emailjs-com";
import "./BlogContent.css";

const BlogContent = () => {
  const [modalIsOpen, setmodalIsOpen] = useState(false);
  const url = process.env.PUBLIC_URL + "/blogs/WPdesign.pdf";
  const [download, setDownload] = useState(false);

  const validite = (val) => {
    let emailid = val.target.value;
    if (emailid.includes("@")) {
      if (!emailid.includes("#" || ".." || ".@" || "_@" || "-@")) {
        if (emailid.includes(".com")) {
          setDownload(true);
        } else if (emailid.includes(".cc")) {
          setDownload(true);
        } else if (emailid.includes(".org")) {
          setDownload(true);
        } else {
          setDownload(false);
        }
      }
    } else {
      setDownload(false);
    }
  };
  {
    /* email js */
  }
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_oaix81l",
        "template_r722a3g",
        e.target,
        "user_hD4EoOQHDr3RkBowxMKdS"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    {
      /* for redirection */
    }
    window.open(
      url,
      "_blank" // <- This is what makes it open in a new window.
    );
  };
  return (
    <div>
      <div className="container">
        <Modal
          className="download-modal"
          overlayClassName="download-modal-overlay"
          closeTimeoutMS={400}
          isOpen={modalIsOpen}
          onRequestClose={() => setmodalIsOpen(false)}
        >
          <form onSubmit={sendEmail} action="/">
            <div className="form-group">
              <label for="email">Enter your email address</label>
              <input
                name="user_mailid"
                type="email"
                id="email"
                required
                className="form-control form-control-lg mt-2"
                placeholder="name@example.com"
                onChange={validite}
              />
              <small className="form-text text-muted">
                We'll never share your email with anyone else.
              </small>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="submit"
                className={
                  download
                    ? "btn btn-primary mt-3"
                    : "btn btn-primary disabled mt-3"
                }
                onClick={() => {
                  setmodalIsOpen(false);
                }}
              >
                Download
              </button>
            </div>
          </form>
        </Modal>
        <div className="row">
          <div className="col-md-12 col-lg-8 blog-content">
            <p className="blog-section-heading">Introduction</p>
            <p>
              This blog post is about how you can automate suspended service
              instances operations with IDE-Cloud automated recovery features.
              It comes as part of a series of 5 that all discuss different
              topics around how to effectively benefit from the Automated
              recovery features of IDE-Cloud. In this blog, we will cover the
              fourth part of the series. Part 1 – How to deal effectively when
              your receive locations get disabled Part 2 – How to improve
              service availability Part 3 – How to optimize your Windows
              resources Part 4 – How to automate suspended instance operations
              Part 5 – How to automatically clean up unneeded service instances
              Importance of monitoring your service instances In order to have a
              healthy and safe BizTalk environment, it’s important to keep an
              eye on the run time service instances and message instances in
              your BizTalk environment.
            </p>
            <div className="alert alert-primary text-center">
              To read more,{" "}
              <button
                className="btn btn-sm btn-link"
                onClick={() => setmodalIsOpen(true)}
              >
                download PDF
              </button>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogContent;
